module.exports = __webpack_public_path__ + "assets/icons/testproject.3035454359fd11330989afe88f355a02.svg";